/**
 * SVG marker definitions for edge arrows.
 * Rendered once inside the ReactFlow component via a panel overlay.
 *
 * Uses markerUnits="userSpaceOnUse" for pixel-stable sizing regardless of
 * stroke width, and refX is set so the arrowhead tip aligns with the
 * connection point (line ends at the back of the arrowhead, not through it).
 */
export function ArrowMarkerDefs() {
  return (
    <svg
      style={{ position: "absolute", width: 0, height: 0 }}
      aria-hidden="true"
    >
      <defs>
        {/* Arrow for markerEnd — tip at connection point, line stops at base */}
        <marker
          id="board-arrow-end"
          viewBox="0 0 12 12"
          refX="11"
          refY="6"
          markerWidth="12"
          markerHeight="12"
          markerUnits="userSpaceOnUse"
          orient="auto"
        >
          <path
            d="M 1 1 L 11 6 L 1 11 Z"
            fill="var(--color-foreground)"
          />
        </marker>

        {/* Arrow for markerStart — flipped via orient so tip points backward */}
        <marker
          id="board-arrow-start"
          viewBox="0 0 12 12"
          refX="1"
          refY="6"
          markerWidth="12"
          markerHeight="12"
          markerUnits="userSpaceOnUse"
          orient="auto"
        >
          <path
            d="M 11 1 L 1 6 L 11 11 Z"
            fill="var(--color-foreground)"
          />
        </marker>
      </defs>
    </svg>
  );
}
